export default __webpack_public_path__ + "static/media/hole-puncher.2519195e.png";